'use client';
import React, { useCallback, memo } from 'react';
import { AdvancedMarker, Pin, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { theme } from '@workspace/ui/theme';

type TreeMarkerProps = {
  position: google.maps.LatLngLiteral;
  featureId: string;
  onMarkerClick?: (marker: google.maps.marker.AdvancedMarkerElement, featureId: string) => void;
  title?: string;
};

const FeatureMarkerComponent = ({ position, featureId, onMarkerClick, title }: TreeMarkerProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const backgroundColor = theme === 'redRec' ? '#004639' : '#CD1543';
  const handleClick = useCallback(
    () => onMarkerClick && onMarkerClick(marker!, featureId),
    [onMarkerClick, marker, featureId],
  );

  return (
    <AdvancedMarker
      title={title}
      ref={markerRef}
      position={position}
      onClick={handleClick}
      className={'transition-transform duration-300 ease-in-out transform hover:scale-110'}
    >
      <Pin glyphColor={'white'} background={backgroundColor} borderColor={backgroundColor} />
    </AdvancedMarker>
  );
};

// Memoize to prevent re-rendering when props haven't changed
export const FeatureMarker = memo(FeatureMarkerComponent);
